import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { patchWebAnimationsStartTime, suppressKnownBrowserExtensionPromiseRejections } from '@marina/utils';
import { AppModule } from './app/app.module';

patchWebAnimationsStartTime();
suppressKnownBrowserExtensionPromiseRejections();

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => console.error(err));
